// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import SERVER from './metaData/server'
export default {
  state: SERVER,
  actions
}
